export const handleEnterKeyPress = (callback) => (event) => {
  if (event.key === 'Enter') {
    event.preventDefault();
    callback();
  }
};
